




































import { Component, Vue } from "vue-property-decorator";

@Component({})

export default class Footer extends Vue {
  name = "footer"
  data() {
    return {
      sitemap: [
        {
          name: "Home",
          url: "/",
        },
        {
          name: "Categories",
          url: "/categories",
        },
        {
          name: "Random",
          url: "/random",
        },
        {
          name: "About",
          url: "/about",
        },
      ]
    }
  }
}
